var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ValidatedForm',_vm._g({attrs:{"fm":_setup.addressFormDef.form},on:{"form-event":_setup.onFormEvent}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }